import { atom } from 'recoil';
import { RecoilAtomKey } from '../../recoilConstantKey';

const leadsTableStateAtom = atom({
  key: RecoilAtomKey.leadsTableStateKey,
  default: {
    cache: {},
    totalCountCache: {},
    uniqueCountCache: {},
    isCampaignOwnerCache: {},
    isCampaignOwner: false,
    data: [],
    totalCount: 0,
    uniquePhoneCount: 0,
    filters: {
      campaign_id: '',
      leads_form_id: '',
      page: 0,
      search: '',
      limit: 100,
      offset: 0,
      status: '',
      start_date: '',
      end_date: '',
      sort_type: '',
      sort_by: '',
      dynamicFilters: [],
    },
    isLoading: false,
  },
});

const campaignDataMapAtom = atom<any>({
  key: RecoilAtomKey.campaignDataMapKey,
  default: {},
});

const campaignLeadManagementAtom = atom<any>({
  key: RecoilAtomKey.campaignLeadManagementKey,
  default: {},
});

const assignedCampaignUserAtom = atom<any>({
  key: RecoilAtomKey.assignedCampaignUserKey,
  default: {},
});

const dynamicWebFormPreviewDataAtom = atom<any>({
  key: RecoilAtomKey.dynamicWebFormPreviewDataKey,
  default: {},
});

export {
  leadsTableStateAtom,
  campaignDataMapAtom,
  campaignLeadManagementAtom,
  assignedCampaignUserAtom,
  dynamicWebFormPreviewDataAtom,
};
